import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ideal-product-long-description-view',
  imports: [],
  templateUrl: './product-long-description-view.component.html',
  styleUrl: './product-long-description-view.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductLongDescriptionViewComponent {
  public readonly description = input.required<string>();
}
